// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Manual Page Styles */

.manual-card {
  border: none;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}

.manual-tabs .nav-link {
  font-weight: 500;
  color: #555;
  padding: 12px 20px;
  border-radius: 8px 8px 0 0;
  transition: all 0.3s ease;
}

.manual-tabs .nav-link:hover {
  color: #2962ff;
  background-color: #f5f8ff;
}

.manual-tabs .nav-link.active {
  color: #2962ff;
  background-color: #fff;
  border-bottom: 3px solid #2962ff;
}

.manual-content {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.section-title {
  color: #1a237e;
  font-size: 1.8rem;
  margin-bottom: 10px;
  padding-bottom: 15px;
  border-bottom: 2px solid #e3f2fd;
}

.manual-content h3 {
  color: #2962ff;
  font-size: 1.4rem;
  margin-top: 30px;
  margin-bottom: 15px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e0e0e0;
}

.manual-content h4 {
  color: #424242;
  font-size: 1.2rem;
  margin-top: 25px;
  margin-bottom: 12px;
}

.manual-content h5 {
  color: #616161;
  font-size: 1.1rem;
  margin-top: 20px;
  margin-bottom: 10px;
}

.manual-content p {
  color: #555;
  line-height: 1.7;
  margin-bottom: 15px;
}

.manual-content ul,
.manual-content ol {
  margin-bottom: 20px;
  padding-left: 25px;
}

.manual-content li {
  margin-bottom: 8px;
  line-height: 1.6;
}

/* Feature List with Icons */
.feature-list {
  list-style: none;
  padding-left: 0;
}

.feature-list li {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
}

.feature-list li svg {
  color: #2962ff;
  flex-shrink: 0;
}

/* Screenshot Placeholder */
.screenshot-placeholder {
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%);
  border: 2px dashed #b0bec5;
  border-radius: 12px;
  padding: 40px 20px;
  text-align: center;
  margin: 25px 0;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.screenshot-placeholder:hover {
  border-color: #2962ff;
  background: linear-gradient(135deg, #e3f2fd 0%, #e8eaf6 100%);
}

.screenshot-placeholder .placeholder-icon {
  color: #90a4ae;
  margin-bottom: 15px;
}

.screenshot-placeholder .placeholder-title {
  font-weight: 600;
  color: #37474f;
  font-size: 1.1rem;
  margin-bottom: 5px;
}

.screenshot-placeholder .placeholder-desc {
  color: #78909c;
  font-size: 0.9rem;
  margin: 0;
}

/* Info Box */
.info-box {
  background-color: #e3f2fd;
  border-left: 4px solid #2962ff;
  padding: 15px 20px;
  border-radius: 0 8px 8px 0;
  margin: 20px 0;
}

.info-box strong {
  color: #1565c0;
}

.info-box code {
  background-color: #fff;
  padding: 2px 8px;
  border-radius: 4px;
  font-family: 'Courier New', monospace;
  color: #d32f2f;
}

/* Formula Box */
.formula-box {
  background-color: #fff3e0;
  border: 1px solid #ffcc80;
  border-radius: 8px;
  padding: 20px;
  margin: 20px 0;
  font-family: 'Courier New', monospace;
}

.formula-box strong {
  color: #e65100;
}

/* Menu Structure */
.menu-structure {
  background-color: #263238;
  border-radius: 8px;
  padding: 20px;
  margin: 20px 0;
}

.menu-structure pre {
  color: #b0bec5;
  font-family: 'Courier New', monospace;
  font-size: 0.9rem;
  margin: 0;
  white-space: pre-wrap;
}

/* Tables */
.manual-table {
  margin: 20px 0;
  border-radius: 8px;
  overflow: hidden;
}

.manual-table thead th {
  background-color: #263238;
  color: #fff;
  font-weight: 600;
  padding: 12px 15px;
  border: none;
}

.manual-table tbody td {
  padding: 10px 15px;
  vertical-align: middle;
}

.manual-table tbody tr:hover {
  background-color: #f5f8ff;
}

/* Alert Boxes */
.manual-content .alert {
  display: flex;
  align-items: center;
  border-radius: 8px;
  margin: 20px 0;
}

.manual-content .alert-warning {
  background-color: #fff8e1;
  border: 1px solid #ffcc80;
  color: #f57c00;
}

.manual-content .alert svg {
  flex-shrink: 0;
}

/* FAQ Items */
.faq-item {
  background-color: #fafafa;
  border-radius: 8px;
  padding: 15px 20px;
  margin: 15px 0;
  border-left: 4px solid #2962ff;
}

.faq-item h5 {
  color: #1a237e;
  margin-top: 0;
  margin-bottom: 10px;
}

.faq-item p {
  margin-bottom: 0;
  color: #616161;
}

/* Responsive Styles */
@media (max-width: 768px) {
  .manual-tabs .nav-link {
    padding: 10px 12px;
    font-size: 0.9rem;
  }

  .manual-tabs .nav-link span {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .manual-content {
    padding: 15px;
  }

  .section-title {
    font-size: 1.4rem;
  }

  .manual-content h3 {
    font-size: 1.2rem;
  }

  .screenshot-placeholder {
    min-height: 150px;
    padding: 30px 15px;
  }

  .menu-structure {
    padding: 15px;
  }

  .menu-structure pre {
    font-size: 0.75rem;
  }
}

/* Print Styles */
@media print {
  .manual-tabs {
    display: none;
  }

  .manual-content {
    padding: 0;
  }

  .screenshot-placeholder {
    border: 1px solid #ccc;
    page-break-inside: avoid;
  }

  .info-box,
  .formula-box,
  .faq-item {
    page-break-inside: avoid;
  }
}

/* Dark Mode Support */
@media (prefers-color-scheme: dark) {
  .screenshot-placeholder {
    background: linear-gradient(135deg, #37474f 0%, #263238 100%);
    border-color: #546e7a;
  }

  .screenshot-placeholder .placeholder-icon {
    color: #78909c;
  }

  .screenshot-placeholder .placeholder-title {
    color: #eceff1;
  }

  .screenshot-placeholder .placeholder-desc {
    color: #90a4ae;
  }
}

/* Smooth scrolling for tabs */
.manual-tabs .tab-content {
  scroll-behavior: smooth;
}

/* Badge alignment in tables */
.manual-table .badge {
  font-size: 0.85rem;
  padding: 6px 10px;
}

/* Lead paragraph */
.manual-content .lead {
  font-size: 1.15rem;
  color: #78909c;
  margin-bottom: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Manual/Manual.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;EACE,YAAY;EACZ,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,6DAA6D;EAC7D,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;AAC/D;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA,aAAa;AACb;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,iBAAiB;EACjB,SAAS;EACT,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,wBAAwB;EAC1B;;EAEA;;;IAGE,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,6DAA6D;IAC7D,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,8BAA8B;AAC9B;EACE,uBAAuB;AACzB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB","sourcesContent":["/* Manual Page Styles */\n\n.manual-card {\n  border: none;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n}\n\n.manual-tabs .nav-link {\n  font-weight: 500;\n  color: #555;\n  padding: 12px 20px;\n  border-radius: 8px 8px 0 0;\n  transition: all 0.3s ease;\n}\n\n.manual-tabs .nav-link:hover {\n  color: #2962ff;\n  background-color: #f5f8ff;\n}\n\n.manual-tabs .nav-link.active {\n  color: #2962ff;\n  background-color: #fff;\n  border-bottom: 3px solid #2962ff;\n}\n\n.manual-content {\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.section-title {\n  color: #1a237e;\n  font-size: 1.8rem;\n  margin-bottom: 10px;\n  padding-bottom: 15px;\n  border-bottom: 2px solid #e3f2fd;\n}\n\n.manual-content h3 {\n  color: #2962ff;\n  font-size: 1.4rem;\n  margin-top: 30px;\n  margin-bottom: 15px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.manual-content h4 {\n  color: #424242;\n  font-size: 1.2rem;\n  margin-top: 25px;\n  margin-bottom: 12px;\n}\n\n.manual-content h5 {\n  color: #616161;\n  font-size: 1.1rem;\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\n\n.manual-content p {\n  color: #555;\n  line-height: 1.7;\n  margin-bottom: 15px;\n}\n\n.manual-content ul,\n.manual-content ol {\n  margin-bottom: 20px;\n  padding-left: 25px;\n}\n\n.manual-content li {\n  margin-bottom: 8px;\n  line-height: 1.6;\n}\n\n/* Feature List with Icons */\n.feature-list {\n  list-style: none;\n  padding-left: 0;\n}\n\n.feature-list li {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 0;\n}\n\n.feature-list li svg {\n  color: #2962ff;\n  flex-shrink: 0;\n}\n\n/* Screenshot Placeholder */\n.screenshot-placeholder {\n  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%);\n  border: 2px dashed #b0bec5;\n  border-radius: 12px;\n  padding: 40px 20px;\n  text-align: center;\n  margin: 25px 0;\n  min-height: 200px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n}\n\n.screenshot-placeholder:hover {\n  border-color: #2962ff;\n  background: linear-gradient(135deg, #e3f2fd 0%, #e8eaf6 100%);\n}\n\n.screenshot-placeholder .placeholder-icon {\n  color: #90a4ae;\n  margin-bottom: 15px;\n}\n\n.screenshot-placeholder .placeholder-title {\n  font-weight: 600;\n  color: #37474f;\n  font-size: 1.1rem;\n  margin-bottom: 5px;\n}\n\n.screenshot-placeholder .placeholder-desc {\n  color: #78909c;\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n/* Info Box */\n.info-box {\n  background-color: #e3f2fd;\n  border-left: 4px solid #2962ff;\n  padding: 15px 20px;\n  border-radius: 0 8px 8px 0;\n  margin: 20px 0;\n}\n\n.info-box strong {\n  color: #1565c0;\n}\n\n.info-box code {\n  background-color: #fff;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-family: 'Courier New', monospace;\n  color: #d32f2f;\n}\n\n/* Formula Box */\n.formula-box {\n  background-color: #fff3e0;\n  border: 1px solid #ffcc80;\n  border-radius: 8px;\n  padding: 20px;\n  margin: 20px 0;\n  font-family: 'Courier New', monospace;\n}\n\n.formula-box strong {\n  color: #e65100;\n}\n\n/* Menu Structure */\n.menu-structure {\n  background-color: #263238;\n  border-radius: 8px;\n  padding: 20px;\n  margin: 20px 0;\n}\n\n.menu-structure pre {\n  color: #b0bec5;\n  font-family: 'Courier New', monospace;\n  font-size: 0.9rem;\n  margin: 0;\n  white-space: pre-wrap;\n}\n\n/* Tables */\n.manual-table {\n  margin: 20px 0;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.manual-table thead th {\n  background-color: #263238;\n  color: #fff;\n  font-weight: 600;\n  padding: 12px 15px;\n  border: none;\n}\n\n.manual-table tbody td {\n  padding: 10px 15px;\n  vertical-align: middle;\n}\n\n.manual-table tbody tr:hover {\n  background-color: #f5f8ff;\n}\n\n/* Alert Boxes */\n.manual-content .alert {\n  display: flex;\n  align-items: center;\n  border-radius: 8px;\n  margin: 20px 0;\n}\n\n.manual-content .alert-warning {\n  background-color: #fff8e1;\n  border: 1px solid #ffcc80;\n  color: #f57c00;\n}\n\n.manual-content .alert svg {\n  flex-shrink: 0;\n}\n\n/* FAQ Items */\n.faq-item {\n  background-color: #fafafa;\n  border-radius: 8px;\n  padding: 15px 20px;\n  margin: 15px 0;\n  border-left: 4px solid #2962ff;\n}\n\n.faq-item h5 {\n  color: #1a237e;\n  margin-top: 0;\n  margin-bottom: 10px;\n}\n\n.faq-item p {\n  margin-bottom: 0;\n  color: #616161;\n}\n\n/* Responsive Styles */\n@media (max-width: 768px) {\n  .manual-tabs .nav-link {\n    padding: 10px 12px;\n    font-size: 0.9rem;\n  }\n\n  .manual-tabs .nav-link span {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n  }\n\n  .manual-content {\n    padding: 15px;\n  }\n\n  .section-title {\n    font-size: 1.4rem;\n  }\n\n  .manual-content h3 {\n    font-size: 1.2rem;\n  }\n\n  .screenshot-placeholder {\n    min-height: 150px;\n    padding: 30px 15px;\n  }\n\n  .menu-structure {\n    padding: 15px;\n  }\n\n  .menu-structure pre {\n    font-size: 0.75rem;\n  }\n}\n\n/* Print Styles */\n@media print {\n  .manual-tabs {\n    display: none;\n  }\n\n  .manual-content {\n    padding: 0;\n  }\n\n  .screenshot-placeholder {\n    border: 1px solid #ccc;\n    page-break-inside: avoid;\n  }\n\n  .info-box,\n  .formula-box,\n  .faq-item {\n    page-break-inside: avoid;\n  }\n}\n\n/* Dark Mode Support */\n@media (prefers-color-scheme: dark) {\n  .screenshot-placeholder {\n    background: linear-gradient(135deg, #37474f 0%, #263238 100%);\n    border-color: #546e7a;\n  }\n\n  .screenshot-placeholder .placeholder-icon {\n    color: #78909c;\n  }\n\n  .screenshot-placeholder .placeholder-title {\n    color: #eceff1;\n  }\n\n  .screenshot-placeholder .placeholder-desc {\n    color: #90a4ae;\n  }\n}\n\n/* Smooth scrolling for tabs */\n.manual-tabs .tab-content {\n  scroll-behavior: smooth;\n}\n\n/* Badge alignment in tables */\n.manual-table .badge {\n  font-size: 0.85rem;\n  padding: 6px 10px;\n}\n\n/* Lead paragraph */\n.manual-content .lead {\n  font-size: 1.15rem;\n  color: #78909c;\n  margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
